export const SMALL_HIDE_BREAKPOINTS = {
  md: {
    md: true,
    lg: true,
    xl: true,
    xxl: true,
  },
  lg: {
    lg: true,
    xl: true,
    xxl: true,
  },
  xl: {
    xl: true,
    xxl: true,
  },
  xxl: {
    xxl: true,
  },
}

export const LARGE_HIDE_BREAKPOINTS = {
  md: {
    xs: true,
    sm: true,
  },
  lg: {
    xs: true,
    sm: true,
    md: true,
  },
  xl: {
    xs: true,
    sm: true,
    md: true,
    lg: true,
  },
  xxl: {
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
  },
}
